const { lightPalette, darkPalette } = require('./palette');
const { typography } = require('./typography');

const uwmLightTheme = {
  palette: lightPalette,
  typography,
};

const uwmDarkTheme = {
  palette: darkPalette,
  typography,
};

module.exports = {
  uwmLightTheme,
  uwmDarkTheme,
};
